import { render, staticRenderFns } from "./pictoSight.vue?vue&type=template&id=389f3ede&scoped=true&"
import script from "./pictoSight.vue?vue&type=script&lang=js&"
export * from "./pictoSight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389f3ede",
  null
  
)

export default component.exports